<template>
    <div id="org_settings_connections_files">
        <div class="d-flex">
            <div class="card mb-3 table-card flex-grow-1" v-if="files.length > 0">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-7 col-12">
                            <h3 class="mt-2"><span v-if="show_archived">Archived </span>Data Files ({{ number_with_zero(local_num_files) }})</h3>
                            <p class="mb-0 text-muted small">Files are automatically removed 30 days after uploading. Downloads are not available for these files.</p>
                        </div>
                        <div class="col-lg-5 d-none d-lg-block">
                            <div class="d-flex justify-content-end justify-self-end gap-2">
                                <div class="position-relative">
                                    <input type="text" class="search-box form-control me-1 py-2" placeholder="Search by File Name..." aria-label="Search by File Name..." v-model="search_key" @input="debouncedSearchOptions">
                                    <i class="fa fa-search search-placeholder-icon" v-if="search_key === ''"></i>
                                </div>

                                <div v-if="!canEdit('connections')" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                    <button class="btn btn-secondary" :disabled="true">
                                        <img class="icon" src="/img/icons/avid-icons/plus.svg" alt="Add">Add File
                                    </button>
                                </div>
                                <button v-else class="btn btn-primary" @click="openAddFileModal()">
                                    <img class="icon" src="/img/icons/avid-icons/plus.svg" alt="Add">Add File
                                </button>
                                
                                <div class="dropdown position-relative filters-dropdown">
                                    <button class="btn btn-secondary dropdown-toggle dropdown-toggle-no-btn" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                                        <img class="icon" src="/img/icons/avid-icons/filter-funnel-01.svg" alt="">
                                        <!-- Red count bubble (inside button for alignment) -->
                                        <span v-if="activeFilterCount > 0" class="position-absolute top-0 start-100 translate-middle badge rounded-pill badge-blue">
                                            {{ activeFilterCount }}
                                        </span>
                                    </button>

                                    <div class="dropdown-menu dropdown-menu-primary ps-3">
                                        <h4>Filters</h4>
                                        <div class="form-check form-switch d-inline-flex align-items-center gap-2">
                                            <input class="form-check-input" type="checkbox" id="archivedSwitch"
                                                   v-model="show_archived" @change="handleArchivedToggle" aria-label="Show Archived">
                                            <label class="form-check-label" for="archivedSwitch">Archived</label>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-body p-0">
                    <div class="table-width-responsive">
                        <table class="table table-with-pagination mb-0">
                            <thead>
                                <tr class="table-header-row">
                                    <th @click="sortByKey('name')" class="d-table-cell">
                                        <div class="d-flex flex-row">
                                            File Name
                                            <div class="d-flex flex-column">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key=='name' && sort_order=='asc')? 'sort-key-active' :''" alt="Sort ascending">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key=='name' && sort_order=='des')? 'sort-key-active' :''" alt="Sort descending">
                                            </div>
                                        </div>
                                    </th>
                                    <th @click="sortByKey('status')" class="d-none d-md-table-cell">
                                        <div class="d-flex flex-row">
                                            Status
                                            <div class="d-flex flex-column">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key=='status' && sort_order=='asc')? 'sort-key-active' :''" alt="Sort ascending">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key=='status' && sort_order=='des')? 'sort-key-active' :''" alt="Sort descending">
                                            </div>
                                        </div>
                                    </th>
                                    <th @click="sortByKey('dataset')" class="d-none d-lg-table-cell">
                                        <div class="d-flex flex-row">
                                            Data Set
                                            <div class="d-flex flex-column">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key=='dataset' && sort_order=='asc')? 'sort-key-active' :''" alt="Sort ascending">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key=='dataset' && sort_order=='des')? 'sort-key-active' :''" alt="Sort descending">
                                            </div>
                                        </div>
                                    </th>
                                    <th @click="sortByKey('size')" class="d-none d-sm-table-cell">
                                        <div class="d-flex flex-row">
                                            Size
                                            <div class="d-flex flex-column">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key=='size' && sort_order=='asc')? 'sort-key-active' :''" alt="Sort ascending">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key=='size' && sort_order=='des')? 'sort-key-active' :''" alt="Sort descending">
                                            </div>
                                        </div>
                                    </th>
                                    <th @click="sortByKey('created_at')" class="d-none d-md-table-cell">
                                        <div class="d-flex flex-row">
                                            Upload Date
                                            <div class="d-flex flex-column">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key=='created_at' && sort_order=='asc')? 'sort-key-active' :''" alt="Sort ascending">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key=='created_at' && sort_order=='des')? 'sort-key-active' :''" alt="Sort descending">
                                            </div>
                                        </div>
                                    </th>
                                    <th @click="sortByKey('deleted_by')" class="table-column-2 d-none d-sm-table-cell" v-if="show_archived">
                                        <div class="d-flex flex-row">
                                            Archived By
                                            <div class="d-flex flex-column">
                                                <img 
                                                    class="sort-key" 
                                                    src="/img/icons/avid-icons/chevron-up.svg" 
                                                    :class="{ 'sort-key-active': sort_key === 'deleted_by' && sort_order === 'asc' }" alt=""
                                                >
                                                <img 
                                                    class="sort-key" 
                                                    src="/img/icons/avid-icons/chevron-down.svg" 
                                                    :class="{ 'sort-key-active': sort_key === 'deleted_by' && sort_order === 'des' }" alt=""
                                                >
                                            </div>
                                        </div>
                                    </th>
                                    <th @click="sortByKey('deleted_at')" class="table-column-2 d-none d-sm-table-cell" v-if="show_archived">
                                        <div class="d-flex flex-row">
                                            Archived Date
                                            <div class="d-flex flex-column">
                                                <img 
                                                    class="sort-key" 
                                                    src="/img/icons/avid-icons/chevron-up.svg" 
                                                    :class="{ 'sort-key-active': sort_key === 'deleted_at' && sort_order === 'asc' }" alt=""
                                                >
                                                <img 
                                                    class="sort-key" 
                                                    src="/img/icons/avid-icons/chevron-down.svg" 
                                                    :class="{ 'sort-key-active': sort_key === 'deleted_at' && sort_order === 'des' }" alt=""
                                                >
                                            </div>
                                        </div>
                                    </th>
                                    <th class="d-table-cell column-sort-disabled pe-3" width="1" v-if="canEdit('connections')">
                                        <div class="d-flex flex-row">Action</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="filtered_file_list.length == 0 && search_key != ''" class="no-results-text">
                                    <td class="align-start" colspan="100%">
                                        <div class="d-flex flex-column align-items-center my-4">
                                            No files found.
                                        </div>
                                    </td>
                                </tr>
                                <tr v-else-if="file_list_shown.length == 0 && show_archived" class="no-results-text">
                                    <td class="align-start" colspan="100%">
                                        <div class="d-flex flex-column align-items-center my-4">
                                            No archived files found.
                                        </div>
                                    </td>
                                </tr>
                                <tr v-else v-for="(file, index) in file_list_shown" :key="file.id">
                                    <td class="d-table-cell align-start" style="max-width: 315px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" :title="file.name" data-bs-toggle="tooltip">
                                        {{ file.name }}
                                        <small class="ms-2"><em>({{ file.source }})</em></small>
                                    </td>
                                    <td class="d-none d-md-table-cell">
                                        <span v-if="file.id >= 0 && (file.status === 'ready' || file.status === 'invalid' || file.status === 'error')">
                                            <span 
                                                class="badge" 
                                                :class="getColorClass(file.status, file)"
                                            >
                                                <span v-if="file.type === 'xlsx' && file.status === 'ready'">
                                                    <div class="d-inline-block spinner-border spinner-border-sm me-1" role="status"></div>
                                                    Extracting Worksheets...
                                                </span>
                                                <span v-else>
                                                    {{ propercase(file.status) }}
                                                    <span v-if="(file.status === 'invalid' || file.status === 'error') && file.status_msg" class="ms-1">
                                                        <i class="fa fa-question-circle" data-bs-toggle="tooltip" :title="file.status_msg"></i>
                                                    </span>
                                                </span>
                                            </span>
                                        </span>
                                        <span v-else class="badge">
                                            <div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status"></div>
                                            <span class="ms-1">
                                                {{ (file.status === 'received' && isDataFile(file)) ? 'Loading Data' : propercase(file.status) }}...
                                            </span>
                                        </span>
                                    </td>
                                    <td class="d-none d-lg-table-cell">
                                        <span v-if="file.dataset"> <a href="#" @click.prevent="viewFile(file)">{{ propercase(file.dataset.name) }}</a></span>
                                        <a class="btn btn-sm btn-secondary py-0" v-else-if="!isDeleted(file) && file.id >= 0 && file.status == 'ready' && isDataFile(file)" :href="'/integrations/'+client.url+'/mapping/file/'+file.id">
                                            <img class="icon pe-0" src="/img/icons/avid-icons/plus.svg" alt="Add">Add
                                        </a>
                                    </td>
                                    <td class="d-none d-sm-table-cell">
                                        {{ fileSize(file.size) }}
                                    </td>
                                    <td class="d-none d-md-table-cell">
                                        <span :title="datetime(file.created_at)" data-bs-toggle="tooltip">
                                            {{ date(file.created_at) }}
                                        </span>
                                    </td>
                                    <td class="table-column-2 d-none d-sm-table-cell" v-if="show_archived">
                                        <div class="user-info">
                                            <img v-if="file.deleted_by" :src="file.deleted_by.photo_url" class="avatar rounded-circle rounded-circle-primary-border bg-white" />
                                            <span>{{ file.deleted_by?.first_name ?? '' }}</span>
                                        </div>
                                    </td>
                                    <td class="table-column-2 d-none d-sm-table-cell" v-if="show_archived">
                                        <span :title="datetime(file.deleted_at)" data-bs-toggle="tooltip">
                                            {{ date(file.deleted_at) }}
                                        </span>
                                    </td>
                                    <td class="d-table-cell"  v-if="canEdit('connections')">
                                        <div class="dropdown" v-if="!isDeleted(file)">
                                            <button class="btn btn-white btn-icon-only-md" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false" aria-label="Button">
                                                <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" data-bs-toggle="tooltip" title="Actions" alt="">
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                                <a v-if="isDataFile(file) && isIncremental(file)" class="dropdown-item" href="#" @click.prevent="rebaseDataset(file)">
                                                    <img class="icon me-2" src="/img/icons/avid-icons/location-cross.svg" alt="Rebase">
                                                    Rebase Data Set to File
                                                </a>
                                                <a v-if="isDataFile(file)" class="dropdown-item" href="#" @click.prevent="previewTable(file)" data-bs-toggle="modal" data-bs-target="#preview-modal">
                                                    <img class="icon me-2" src="/img/icons/avid-icons/eye.svg" alt="Preview">
                                                    Preview File
                                                </a>
                                                <a v-if="withinThirtyDays(file)" class="dropdown-item" :href="'/integrations/'+ client.url +'/files/download/'+ file.id" target="_blank">
                                                    <img class="icon me-2" src="/img/icons/avid-icons/download.svg" alt="Download">
                                                    Download File
                                                </a>
                                                <a v-if="isDataFile(file) && file.status === 'ready'" class="dropdown-item" href="#" @click.prevent="addSegment(file, $event)" :class="{ 'disabled': form.saving }">
                                                    <img v-if="!form.saving" class="icon me-2" src="/img/icons/avid-icons/user-add.svg" alt="Add Audience">
                                                    <div v-else class="d-inline-block spinner-border spinner-border-sm me-2 ms-1" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                    <span v-if="form.saving"> Creating Audience...</span>
                                                    <span v-else> Add Audience</span>
                                                </a>
                                                
                                                <hr class="my-1">
                                                <a class="dropdown-item text-danger" href="#" @click.prevent="removeFile(file)">
                                                    <img class="icon red-icon me-2" src="/img/icons/avid-icons/archive-2.svg" alt="Archive">
                                                    Archive  File
                                                </a>
                                            </div>
                                        </div>
                                        <div class="dropdown d-flex justify-content-center" v-if="isDeleted(file)">
                                            <button class="btn btn-none p-2" @click.prevent="restoreFile(file)" data-bs-toggle="tooltip" title="Restore file">
                                                <img class="pe-0" src="/img/icons/avid-icons/undo.svg" alt="">
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot class="table-border-bottom-0">
                                <tr>
                                    <td colspan="100%" class="py-0">
                                        <div class="table-pagination">
                                            <div class="table-pagination--group d-none d-md-flex">
                                                <div class="position-relative">
                                                    <select class="form-select" name="num_per_page" id="num_per_page" v-model="num_per_page" @change="reloadPagination()" aria-label="Num Per Page">
                                                        <option value="5000">ALL</option>
                                                        <option v-for="num in num_per_page_options" :key="num" :value="num">{{ num }}</option>
                                                    </select>
                                                    <div class="select-display-text">
                                                        Showing {{ num_per_page === 5000 ? 'ALL' : num_per_page }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="table-pagination--group d-none d-lg-flex">
                                                {{ local_num_files ==0 ? '0' : item_interval }} of {{ number_with_zero(local_num_files) }}
                                            </div>

                                            <div class="table-pagination--group">
                                                <button v-if="local_num_files/num_per_page>1" class="btn btn-secondary btn-icon-only-md me-1" @click="moveToPrevPage()" :disabled="page_index == 0" data-bs-toggle="tooltip" title="Previous page">
                                                    <img class="icon" src="/img/icons/avid-icons/chevron-left.svg" alt="Previous">
                                                </button>

                                      
                                                <div class="d-flex page-selector" v-if="local_num_files/num_per_page<=3">
                                                    <button v-for="page in page_index_array" :key="page" class="btn btn-none btn-icon-only-md" :class="page ==page_index + 1 ? 'current-page':''" @click="moveToPage(page)">
                                                        {{page}}
                                                    </button>
                                                </div>
                                                <div class="d-flex page-selector" v-else>
                                                    <button v-for="page in page_index_array.slice(0,2)" :key="page" class="btn btn-none btn-icon-only-md" :class="page ==page_index + 1 ? 'current-page':''" @click="moveToPage(page)">
                                                        {{page}}
                                                    </button>

                                                    <button v-if="page_index > 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled>
                                                        ...
                                                    </button>
                                                    <button v-if="page_index >= 2 && page_index< Math.ceil(local_num_files/num_per_page) -1" class="btn btn-none btn-icon-only-md current-page">
                                                        {{page_index + 1 }}
                                                    </button>

                                                    <button v-if="page_index < local_num_files/num_per_page -2" class="btn btn-none btn-icon-only-md text-nowrap" disabled aria-hidden="true">
                                                        ...
                                                    </button>
                                                    <button class="btn btn-none btn-icon-only-md" :class="page_index == Math.ceil(local_num_files/num_per_page)-1 ? 'current-page':''" @click="moveToPage(Math.ceil(local_num_files/num_per_page))">
                                                        {{ Math.ceil(local_num_files/num_per_page) }}
                                                    </button>
                                                </div>

                                                <button v-if="page_count>=1" class="btn btn-secondary btn-icon-only-md ms-1" @click="moveToNextPage()" :disabled="page_index == Math.ceil(local_num_files/num_per_page) -1" data-bs-toggle="tooltip" title="Next page">
                                                    <img class="icon" src="/img/icons/avid-icons/chevron-right.svg" alt="Next">
                                                </button>                                                    
                                     

                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>                        
                    </div>
                </div>
            </div>

            <div v-else class="mt-2 mx-2">
                <h4>No files have been uploaded yet.</h4>
                <p>Upload your first data file to get started.</p>
                <file-modal 
                    v-if="file_connection"
                    :client="client" 
                    :connection="file_connection" 
                    :is-in-modal="false"
                    @fileUploaded="handleFileUploaded"
                ></file-modal>
            </div>
        </div>

        <p class="m-2" v-if="files.length > 0">Need more help with troubleshooting file uploads or setting up your SFTP?
            <a href="https://help.avidai.com/hc/en-us/articles/42928630097683-How-Do-I-Troubleshoot-File-Uploads-and-SFTP-Information" target="_blank">Check Avid's Knowledge Base.</a>
        </p>

        <div class="modal fade px-0" id="preview-modal">
            <div class="modal-dialog" :class="modal_size">
                <div class="modal-content">
                    <div class="modal-header border-bottom-0 pb-0">
                        <div class="text-center w-100">
                            <button type="button" class="btn btn-white float-end close-modal" data-bs-dismiss="preview-modal" @click="closePreviewModal()">
                                <img class="icon me-0" src="/img/icons/avid-icons/close.svg" alt=""> 
                            </button>
                            <h3 class="mt-2 mb-3">Preview File Contents</h3>

                        </div>
                    </div>
                    <div class="modal-body p-0">
                        <div v-if="typeof table_data === 'string' && table_data == ''" class="m-2 mb-4 d-flex flex-column gap-2 align-items-center">
                            <div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <h4 class="text-center">Loading File Contents</h4>
                        </div>
                        <div v-else-if='Array.isArray(table_data) && table_data.length > 0'>
                            <div class="card table-card table-responsive">
                                <table class="table table-with-pagination table-striped mb-0">
                                    <thead>
                                        <tr class="table-header-row">
                                            <th v-for="(row, index) in Object.keys(table_data[0])" class='align-middle'
                                                :class="(index==0) ? 'ps-3' : ''">{{originalHeader(row)}}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="row in table_data" >
                                            <td v-for="(col, index) in row" :class="(index==0) ? 'ps-3' : ''">{{ col }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div v-else-if='Array.isArray(table_data) && table_data.length == 0'>
                            <div class="alert alert-danger m-2"  >
                                No data was returned.
                            </div>
                        </div>
                        <div v-else>
                            <div class="alert alert-danger m-2" >
                                There was an error pulling the data:<br>
                                <em>{{table_data}}</em>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import debounce from 'lodash.debounce';
    import { defineComponent } from 'vue';
    import permissionsMixin from '../../mixins/permissions';
    import { useNotifications } from '../../composables/useNotifications';
    import FileModal from './FileModal.vue';

    export default defineComponent({

        mixins: [permissionsMixin],
        components: {
            FileModal
        },
        setup() {
            const { showNotification } = useNotifications();
            return {
                showNotification
            };
        },
        props: ['client', 'files', 'num_files', 'file_connection'],
        data() {
            return {
                local_connection: null,
                filtered_file_list: [],
                file_list_shown:[],
                search_key: '',

                sort_key: null,
                sort_order: 'asc',
                // filters: {},
                // pagination
                num_per_page: 25, // default to 25
                show_archived: false,
                num_per_page_options: [5,10,15,20,25,30,50,100],
                page_count: null,
                page_index: 0,
                page_index_array: [],
                item_interval: '',
                // preview modal
                modal_size: 'modal-xl',
                table_data: null,
                current_file: null,
                local_num_files: null,
                form: {
                    saving: false
                },
            };
        },
        watch: {
            files: {
                handler(newValue) {
                    if (newValue && newValue.length > 0) {
                        this.filtered_file_list = [...newValue].filter(f=>!this.shouldHideFile(f));
                        this.reloadPagination();
                    }
                },
                immediate: true
            },
            num_files: {
                handler(newValue) {
                    this.local_num_files = newValue;
                },
                immediate: true
            }
        },
        beforeMount() {
            this.local_num_files = this.num_files;
            this.debouncedSearchOptions = debounce(this.searchFiles, 500);
            
            // Initialize files if they exist
            if (this.files && this.files.length > 0) {
                this.filtered_file_list = this.files.filter(f=>!this.shouldHideFile(f));
                this.reloadPagination();
            }
            
            this.local_connection = this.connection;
            this.listenForFileUpdates();
        },
        beforeUnmount() {
            // Clean up Pusher subscription
            window.Echo.leaveChannel(`file.${this.client.url}`);
        },
        mounted() {
            this.initializeTooltips();
        },
        methods: {
            initializeTooltips() {
                // Destroy existing tooltips first to prevent duplicates and ensure clean state
                const existingTooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                existingTooltips.forEach(el => {
                    const tooltip = window.bootstrap.Tooltip.getInstance(el);
                    if (tooltip) {
                        tooltip.dispose();
                    }
                });

                // Initialize new tooltips
                const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

                // Add event listeners for hiding tooltips
                for (var i = 0; i < tooltipTriggerList.length; i++) {
                    (function(index) {
                        tooltipTriggerList[index].addEventListener('click', function() {
                            // Hide the tooltip using the index passed to the closure
                            tooltipList[index].hide();
                        });
                        tooltipTriggerList[index].addEventListener('mouseleave', function() {
                            // Hide the tooltip using the index passed to the closure
                            tooltipList[index].hide();
                        });
                    })(i);
                }
            },

            addSegment(file, event) {
                // Prevent dropdown from closing
                event.stopPropagation();
                
                this.form.saving = true;
                //Call the API to create a segment from the file
                window.axios.post(`/api/segment/${this.client.url}/file/${file.id}`)
                    .then(response => {
                        this.form.saving = false;
                        //Redirect to the segment page
                        window.location.href = `/audience/${this.client.url}/${response.data.segment.id}?file_segment=true`;
                    })
                    .catch(error => {
                        this.form.saving = false;
                        if(error.response.status === 400) {
                            //Show a swal error message
                            Swal.fire({
                                title: 'Error Creating Audience',
                                text: "We could not find a column in your data that matches the ID column in your CRM. You'll be redirected to the Audience Creation page where you can create the mapping manually.",
                                icon: 'error',
                                customClass: {
                                    popup: 'swal-error'
                                }
                            }).then(() => {
                                window.location.href = `/audience/${this.client.url}/new`;
                            });
                        } else if(error.response.status === 404) {
                            //Show a swal error message
                            Swal.fire({
                                title: 'Finish Mapping Your Data',
                                text: "Before we can build segments from your uploaded files, we need to finalize your CRM integration. Please contact Avid support for additional help.",
                                icon: 'error',
                                customClass: {
                                    popup: 'swal-error'
                                }
                            });
                        } else {
                            //Show a swal error message
                            Swal.fire({
                                title: 'Error Creating Audience',
                                text: "There was an error creating your audience. Please try again shortly.",
                                icon: 'error',
                                customClass: {
                                    popup: 'swal-error'
                                }
                            });
                        }
                    });
            },

            listenForFileUpdates() {
                window.Echo.channel(`file.${this.client.url}`)
                    .listen('FileStatusUpdated', (e) => {
                        // Update file in filtered_file_list if it exists
                        const index = this.filtered_file_list.findIndex(f => f.id === e.id);
                        if (index !== -1) {
                            if(this.shouldHideFile(e)) {
                                // remove
                                this.filtered_file_list.splice(index,1);
                            } else {
                                // update
                                this.filtered_file_list.splice(index,1,{
                                    ...this.filtered_file_list[index],
                                    ...e
                                });
                                
                                // If this is an xlsx file that just became ready, schedule it for delayed hiding
                                if (e.type === 'xlsx' && e.status === 'ready') {
                                    this.scheduleXlsxFileHiding(e.id);
                                }
                            }
                        } else {
                            // File not found in current list - this might be a newly uploaded file
                            if(!this.shouldHideFile(e)) {
                                // Add the new file to the list
                                this.filtered_file_list.unshift(e);
                                this.local_num_files++;
                                
                                // If this is an xlsx file that just became ready, schedule it for delayed hiding
                                if (e.type === 'xlsx' && e.status === 'ready') {
                                    this.scheduleXlsxFileHiding(e.id);
                                }
                            }
                        }

                        // After modifications, filter again
                        this.filtered_file_list = this.filtered_file_list.filter(f=>!this.shouldHideFile(f));

                        this.reloadPagination();
                        
                        // Re-initialize tooltips after DOM updates
                        this.$nextTick(() => {
                            this.initializeTooltips();
                        });
                    });
            },
            rebaseDataset(file) {
                Swal.fire({
                  title: "Are you sure you want to rebase your data set with this file?",
                  text: "Over time it is necessary to do a full refresh for incremental data loads to reset " +
                    " records that may be missing or have changed. If you proceed, all files uploaded prior "+
                    " to this one that are used with the " + file.dataset.name + " data set will be deleted.",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Yes, delete prior files",
                  customClass: {
                    popup: 'swal-warning'
                  },
                }).then((result) => {
                  if (result.isConfirmed) {

                    this.disable_actions = true;
                    let params = {
                        file_id: file.id
                    };

                    window.axios.post('/api/files/'+this.client.url+'/rebase', params).then(response => {
                        //Remove the files in the given list of removed files
                        let ids_to_remove = response.data.removed_files;

                        this.filtered_file_list = [...this.files];
                        for(let i = 0; i < this.filtered_file_list.length; i++){
                            //If the file id is in the array, remove it
                            if(ids_to_remove.includes(this.filtered_file_list[i].id)){
                                this.filtered_file_list.splice(i, 1);
                                i--;
                            }
                        }
                        this.reloadPagination();
                        this.search_key = "";
                        this.$forceUpdate();
                        
                        // Re-initialize tooltips after rebase
                        this.$nextTick(() => {
                            this.initializeTooltips();
                        });

                        Swal.fire({
                            title: "Success!",
                            text: "The prior files have been removed and the data set will rebuild shortly.",
                            icon: "success",
                            customClass: {
                                popup: 'swal-success'
                            },
                        });
                    });
                }
                });
            },            
            getColorClass(word, file) {
                if(word === 'received' || word === 'processing' || word === 'analyzing') {
                    return 'badge-warning';
                }
                if(word === 'ready') {
                    // If it's an xlsx file that's ready, it's actually extracting worksheets, so show warning
                    if (file && file.type === 'xlsx') {
                        return 'badge-warning';
                    }
                    return 'bg-green bg-icon-success';
                }
                return 'bg-red bg-icon-danger';
            },
            isDataFile(file) {
                // If the file type is a csv, tab, tsv, or txt
                if (file.table_name != null && file.columns != null) {
                    return true;
                }
                
                // Also check file extension for newly uploaded files that haven't been processed yet
                if (file.type && ['csv', 'tsv', 'tab', 'txt'].includes(file.type.toLowerCase())) {
                    return true;
                }
                
                // Check file name extension as fallback
                if (file.name) {
                    const extension = file.name.split('.').pop().toLowerCase();
                    return ['csv', 'tsv', 'tab', 'txt'].includes(extension);
                }
                
                return false;
            },
            isIncremental(file) {
                if(file.dataset == null || file.dataset.settings == null || file.dataset.settings.refresh_type == null)
                    return false;
                return file.dataset.settings.refresh_type == 'incremental';
            },
            previewTable(file) {
                var self = this;
                this.current_file = file;
                this.table_data = "";

                window.axios.post('/api/bigquery/get_detailed_samples', {'data_source': 'file', 'data_source_id': file.id, 'client_id' : this.client.id}).then(response => {
                    self.table_data = response.data.samples;

                  }).catch(function (error) {
                    self.table_data = error;
                  })
            },
            closePreviewModal() {
                var myModalEl = document.getElementById('preview-modal')
                var modal = bootstrap.Modal.getInstance(myModalEl)
                modal.hide();
            },
            originalHeader(value) {
                //Do a foreach loop through this.current_file.columns with a key/val
                for (var key in this.current_file.columns) {
                    if(key == value)
                        return this.current_file.columns[key];
                }
                return value;
            },
            withinThirtyDays(file) {
                //If the file.created_at is within the last 30 days
                return moment().subtract(30, 'days').isBefore(file.created_at) && file.gcs_processed_path != null;
            },
            removeFile(file) {
                var self  = this;
                Swal.fire({
                  title: "Are you sure you want to archive <em>" + file.name + "</em>?",
                  text: "This will remove the file from the system and prevent it from being used with future data processes.",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Yes, archive",
                  customClass: {
                    popup: 'swal-warning'
                  },
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.axios.delete('/api/files/' + self.client.url + '/destroy/' + file.id)
                            .then(response => {

                                const fileName = file.name || 'Your file';
                                self.showNotification({
                                    text: '<strong>' + fileName + '</strong> was archived!'
                                });
                                var index = self.filtered_file_list.findIndex(f => f.id == file.id);
                                self.filtered_file_list.splice(index, 1);
                                this.local_num_files--;
                                this.reloadPagination();
                                
                                // Re-initialize tooltips after file removal
                                this.$nextTick(() => {
                                    this.initializeTooltips();
                                });
                            });
                    }
                });
            },
            reloadPagination(){
                const visibleList = this.filtered_file_list.filter(f=>!this.shouldHideFile(f));
                this.file_list_shown = visibleList.slice(0, Math.min(this.num_per_page, visibleList.length));
                this.page_count = Math.ceil(this.local_num_files / this.num_per_page);
                // this.page_index = 0;
                this.page_index_array = Array.from({length: this.page_count}, (_, i) => i + 1);
                this.getItemInterval();
                
                // Re-initialize tooltips after pagination changes
                this.$nextTick(() => {
                    this.initializeTooltips();
                });
            },
            getItemInterval(){
                if (this.local_num_files > 0){
                    var from = this.page_index * this.num_per_page + 1;
                    var to = (this.page_index +1) * this.num_per_page;
                    if(this.local_num_files && to>this.local_num_files)
                        to = this.local_num_files;
                    if (from >= to)
                        this.item_interval = to
                    else
                        this.item_interval = from +' - ' +to;
                } else {
                    this.item_interval = '0'
                }
            },
            
            getFromDB() {
                window.axios.post('/api/files/' + this.client.url + '/list_by_pattern',
                {
                    'pattern': '%'+this.search_key+'%',
                    'page_size':this.num_per_page,
                    'offset' : this.num_per_page* this.page_index,
                    'archived': this.show_archived
                }).then(response => {
                    let filesFromApi = [];
                    if (Array.isArray(response.data.files)) {
                        filesFromApi = response.data.files;
                    } else if (response.data.files && typeof response.data.files === 'object') {
                        filesFromApi = Object.values(response.data.files);
                    }
                    this.filtered_file_list = filesFromApi.filter(f=>!this.shouldHideFile(f));
                    this.local_num_files = response.data.num_files;
                    this.reloadPagination();
                    this.$forceUpdate();
                    
                    // Re-initialize tooltips after database fetch
                    this.$nextTick(() => {
                        this.initializeTooltips();
                    });
                });
            },
            moveToPrevPage(){
                this.page_index--;
                this.getFromDB();
            },
            moveToPage(page){
                this.page_index = page-1;
                this.getFromDB();
            },
            moveToNextPage(){
                this.page_index++;
                this.getFromDB();
            },
            searchFiles(){
                this.page_index = 0;

                if(this.search_key == "") {
                    this.filtered_file_list = [...this.files.filter(opt=>!this.shouldHideFile(opt))];
                    this.local_num_files = this.num_files;

                    this.reloadPagination();
                } else if (this.num_files < 100) { // for orgs with small file list
                    this.filtered_file_list = this.files.filter(option => option.name.toLowerCase().includes(this.search_key.toLowerCase()) && !this.shouldHideFile(option));
                    this.local_num_files = this.filtered_file_list.length;
                    this.reloadPagination();
                } else { // for orgs with big file list
                    window.axios.post('/api/files/' + this.client.url + '/list_by_pattern',
                    {
                        'pattern': '%'+this.search_key+'%',
                        'page_size':this.num_per_page,
                        'offset' : this.num_per_page* this.page_index,
                        'archived': this.show_archived
                    }).then(response => {
                        let filesFromApi = [];
                        if (Array.isArray(response.data.files)) {
                            filesFromApi = response.data.files;
                        } else if (response.data.files && typeof response.data.files === 'object') {
                            filesFromApi = Object.values(response.data.files);
                        }
                        this.filtered_file_list = filesFromApi.filter(f=>!this.shouldHideFile(f));
                        this.local_num_files = response.data.num_files;
                        this.reloadPagination();
                    });
                }
                
                // Re-initialize tooltips after search results update
                this.$nextTick(() => {
                    this.initializeTooltips();
                });
            },
            sortByKey(key){
                this.sort_key = key;
                if (this.sort_key != key){
                    this.sort_order = 'asc'; // reset to ascending sorting order
                } else{
                    this.sort_order = (this.sort_order == 'asc'? 'des':'asc');
                }
                this.sortDataWithLabel();
            },
            sortDataWithLabel(){
                if (this.sort_key == 'dataset'){
                    if(this.sort_order == 'asc')
                        this.filtered_file_list.sort((a, b) => {
                            if (!a.dataset)
                                return -1;
                            if (!b.dataset)
                                return 1;
                            return (a.dataset.name > b.dataset.name) ? 1 : -1;
                        });
                    else
                        this.filtered_file_list.sort((a, b) => {
                            if (!a.dataset)
                                return 1;
                            if (!b.dataset)
                                return -1;
                            return (a.dataset.name < b.dataset.name) ? 1 : -1;
                        });
                }else{
                    if(this.sort_order == 'asc')
                        this.filtered_file_list.sort((a, b) => (a[this.sort_key ] > b[this.sort_key ]) ? 1 : -1);
                    else
                        this.filtered_file_list.sort((a, b) => (a[this.sort_key ] < b[this.sort_key ]) ? 1 : -1);
                }
                this.reloadPagination();
            },
            viewFile(file){
                this.$emit('viewFile', file)
            },
            openAddFileModal(){
                this.$emit('openAddFileModal', null)
            },
            handleFileUploaded(file) {
                // Ensure the file has all necessary properties for proper display
                const completeFile = {
                    ...file,
                    // Ensure these properties exist for proper rendering
                    id: file.id || -1,
                    status: file.status || 'ready',
                    source: file.source || 'Upload',
                    created_at: file.created_at || new Date().toISOString(),
                    size: file.size || 0,
                    // Add default values for data file detection
                    table_name: file.table_name || null,
                    columns: file.columns || null,
                    // Ensure proper type detection
                    type: file.type || file.name.split('.').pop().toLowerCase()
                };
                
                // Check if the file already exists in the list to avoid duplicates
                const existingIndex = this.filtered_file_list.findIndex(f => f.id === completeFile.id);
                if (existingIndex !== -1) {
                    // Update existing file
                    this.filtered_file_list.splice(existingIndex, 1, completeFile);
                } else {
                    // Add new file to the main list
                    this.filtered_file_list.unshift(completeFile);
                    this.local_num_files++;
                }
                
                this.reloadPagination();

                // Re-initialize tooltips after file addition
                this.$nextTick(() => {
                    this.initializeTooltips();
                });
            },
            shouldHideFile(file){
                // Hide zip and xlsxfiles when they are ready (after extraction/processing)
                return (file.type === 'zip' && file.status === 'ready') || (file.type === 'xlsx' && file.status === 'ready');
            },
            fileSize(bytes) {
                if (isNaN(bytes) || bytes === null) return '---';
                if (bytes === 0) return '0 Bytes';
                const k = 1024;
                const sizes = ['Bytes', 'KB', 'MB', 'GB'];
                const i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
            },
            scheduleXlsxFileHiding(fileId) {
                // Wait a bit for CSV files to be uploaded, then check if we should hide the xlsx
                setTimeout(() => {
                    const index = this.filtered_file_list.findIndex(f => f.id === fileId);
                    if (index !== -1) {
                        const xlsxFile = this.filtered_file_list[index];
                        
                        // Check if there are CSV files that might have been extracted from this xlsx
                        // Look for CSV files with similar names (without extension) that were uploaded recently
                        const xlsxNameWithoutExt = xlsxFile.name.replace(/\.xlsx?$/i, '');
                        const recentCsvFiles = this.filtered_file_list.filter(f => 
                            f.type === 'csv' && 
                            f.name.includes(xlsxNameWithoutExt) &&
                            f.source === 'Upload' &&
                            Math.abs(new Date(f.created_at) - new Date(xlsxFile.created_at)) < 60000 // Within 1 minute
                        );
                        
                        // If we found CSV files that were likely extracted from this xlsx, hide the xlsx file
                        if (recentCsvFiles.length > 0) {
                            this.filtered_file_list.splice(index, 1);
                            this.local_num_files--;
                            this.reloadPagination();
                            // Re-initialize tooltips after hiding
                            this.$nextTick(() => {
                                this.initializeTooltips();
                            });
                        }
                    }
                }, 2000); // Wait 2 seconds for CSV files to be uploaded
                
                // Fallback: hide the xlsx file after 10 seconds regardless, to prevent it from staying visible indefinitely
                setTimeout(() => {
                    const index = this.filtered_file_list.findIndex(f => f.id === fileId);
                    if (index !== -1) {
                        this.filtered_file_list.splice(index, 1);
                        this.local_num_files--;
                        this.reloadPagination();
                        // Re-initialize tooltips after hiding
                        this.$nextTick(() => {
                            this.initializeTooltips();
                        });
                    }
                }, 10000); // Fallback after 10 seconds
            },
            handleArchivedToggle(){
                this.page_index = 0;
                this.getFromDB();
            },
            deletedBy(file){
                if (file.deleted_by?.name === undefined) {
                    return 'Archived on ' + file.deleted_at_formatted;
                }
                return 'Archived by ' + file.deleted_by.name + ' on ' + file.deleted_at_formatted;
            },
            isDeleted(file){
                return file.deleted_at !== null && file.deleted_at !== undefined;
            },
            restoreFile(file){
                window.axios.post(`/api/files/${this.client.url}/restore/${file.id}`)
                    .then(res=>{
                        const restored = res.data.file;
                        const idx = this.filtered_file_list.findIndex(f=>f.id===restored.id);
                        if (idx!==-1) {
                            this.filtered_file_list.splice(idx,1,restored);
                        }
                        const idx2 = this.files.findIndex(f=>f.id===restored.id);
                        if (idx2!==-1) {
                            this.files.splice(idx2,1,restored);
                        }        
                        this.getFromDB();
                        const fileName = restored.name || 'Your file';
                        this.showNotification({
                            text: '<strong>' + fileName + '</strong> has been restored!'
                        });
                    });
            },
        },
        computed: {
            activeFilterCount() {
                let count = 0;
                if (this.show_archived) count++;
                return count;
            }
        }
    })
</script>